import { OnInit, Component, Inject, ViewChild, ElementRef, AfterViewInit } from '@angular/core';
import { MatDialog, MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';
import { DomSanitizer, SafeUrl } from '@angular/platform-browser';
import { CLineDec, GradeManager } from 'src/app/classes/decorticage/info-decorticage';
import { CUtilForme } from 'src/app/classes/info-forme';
import { WMeshAxesInformation, JsLineWMesh, Grade } from 'src/app/classes/json-interface';
import { WMeshUtils } from 'src/app/classes/mesh-utils';
import { CUtilit } from 'src/app/classes/utilit';
import { g_params } from 'src/app/classes/global-param';
import { TranslateService } from '@ngx-translate/core';
import {ArmaServServerMethods} from '../../../classes/ArmaServServerMethods';

interface ModalData {
  lineDec: CLineDec;
  arrayGrade: Grade[];
}

type WMeshAxes = 'VERTICAL'|'HORIZONTAL';

type MeshInputType = 'diameter'|'length'|'step'|'offsets'|'startOffset'|'endOffset'|'nbBars';

@Component({
    templateUrl: './dialogSpecialMesh.html',
    styleUrls: ['./dialogSpecialMesh.css']
})
// tslint:disable-next-line:component-class-suffix TODO
export class DialogSpecialMesh implements OnInit, AfterViewInit {

  @ViewChild('itemNumber', {static: true}) mInputItemNumber!: ElementRef<HTMLInputElement>;
  @ViewChild('itemName', {static: true}) mInputItemName!: ElementRef<HTMLInputElement>;
  @ViewChild('remark', {static: true}) mInputRemark!: ElementRef<HTMLInputElement>;
  @ViewChild('quantity', {static: true}) mInputQuantity!: ElementRef<HTMLInputElement>;
  @ViewChild('barmark', {static: true}) mInputBarmark!: ElementRef<HTMLInputElement>;
  @ViewChild('nbBarsVertical', {static: true}) mInputNbBarVertical!: ElementRef<HTMLInputElement>;
  @ViewChild('nbBarsHorizontal', {static: true}) mInputNbBarHorizontal!: ElementRef<HTMLInputElement>;
  @ViewChild('stepVertical', {static: true}) mInputStepVertical!: ElementRef<HTMLInputElement>;
  @ViewChild('stepHorizontal', {static: true}) mInputStepHotizontal!: ElementRef<HTMLInputElement>;
  @ViewChild('diameterVertical', {static: true}) mInputDiameterVertical!: ElementRef<HTMLInputElement>;
  @ViewChild('diameterHorizontal', {static: true}) mInputDiameterHorizontal!: ElementRef<HTMLInputElement>;
  @ViewChild('totalLengthVertical', {static: true}) mInputLengthVertical!: ElementRef<HTMLInputElement>;
  @ViewChild('totalLengthHorizontal', {static: true}) mInputLengthHorizontal!: ElementRef<HTMLInputElement>;

  @ViewChild('startMeasureVertical', {static: true}) mInputStartMeasureVertical!: ElementRef<HTMLInputElement>;
  @ViewChild('startMeasureHorizontal', {static: true}) mInputStartMeasureHorizontal!: ElementRef<HTMLInputElement>;
  @ViewChild('endMeasureVertical', {static: true}) mInputEndMeasureVertical!: ElementRef<HTMLInputElement>;
  @ViewChild('endMeasureHorizontal', {static: true}) mInputEndMeasureHorizontal!: ElementRef<HTMLInputElement>;

  @ViewChild('canvasMesh', {static: false}) mCanvasMesh!: ElementRef<HTMLCanvasElement>;

  @ViewChild('rightSide', {static: true}) mDivRightSide!: ElementRef<HTMLDivElement>;

  public HTML_TotalLengthVertical: string = '';
  public HTML_TotalLengthHorizontal: string = '';

  public canvasHeight: number = 0;
  public canvasWidth: number = 0;

  public HTML_ShowRealShape: boolean;

  public HTML_SafeUrlImgShape?: SafeUrl;

  private readonly mArrayGrade: Grade[];

  public HTML_TotalWeightRounded?: number = undefined;

  public NbMinQtyMesh: number = 1;

  readonly HTML_MESH_INPUT_ID = {
    totalLengthVertical: `total-length-Vertical`,
    nbBarsVertical: 'nb-Bars-Vertical',
    stepVertical: 'step-Vertical',
    diameterVertical: 'diameter-Vertical',
    startMeasureVertical: 'start-Measure-Vertical',
    endMeasureVertical: 'end-Measure-Vertical',

    totalLengthHorizontal: 'total-length-Horizontal',
    nbBarsHorizontal: 'nb-Bars-Horizontal',
    stepHorizontal: 'step-Horizontal',
    diameterHorizontal: 'diameter-Horizontal',
    startMeasureHorizontal: 'start-Measure-Horizontal',
    endMeasureHorizontal: 'end-Measure-Horizontal'
  };

  public readonly unitDimPlaqueMesh = g_params.unitDimPlaqueMeshStr();

  public static async openDialog(matDialog: MatDialog, lineDec: CLineDec, arrayGrade: Grade[]): Promise<CLineDec|boolean> {
    const modalData: ModalData = { lineDec: lineDec, arrayGrade: arrayGrade };
    const dialogParamRef = matDialog.open(DialogSpecialMesh, {
      height: '80%',
      width: '80%',
      disableClose: true,
      data: modalData
    });
    return dialogParamRef.afterClosed().toPromise();
  }

  public readonly mCpyAnaLine: CLineDec;

  constructor(
    public mDialogRef: MatDialogRef<DialogSpecialMesh>,
    @Inject(MAT_DIALOG_DATA) modalData: ModalData,
    private mArmaServMethods: ArmaServServerMethods,
    private mDomSanitizer: DomSanitizer,
    private mDialog: MatDialog,
    private mTranslate: TranslateService
  ) {
    this.mCpyAnaLine = new CLineDec();
    this.mCpyAnaLine.update(modalData.lineDec);
    this.mArrayGrade = modalData.arrayGrade;
    setTimeout(() => this.loadDataFromLine());
    this.HTML_ShowRealShape = CUtilit.loadOrInitUserParam().ImageType == 'Full';
  }

  ngOnInit(): void {
    // Recup de la taille disponible a vide pour insert une image
    this.canvasHeight = this.mDivRightSide.nativeElement.scrollHeight;
    this.canvasWidth = this.mDivRightSide.nativeElement.offsetWidth;
    this.NbMinQtyMesh = g_params.nbMinMesh;
  }

  ngAfterViewInit(): void {
    setTimeout(() => {
      this.calcTotalLength(this.generateMeshAxesValue('VERTICAL'), this.generateMeshAxesValue('HORIZONTAL'));
      this.drawMesh().catch(console.error);
    });
  }

  public onInputFocusIn(event: FocusEvent) {
    if (((event.target) as HTMLInputElement).id != '') {
      this.drawMesh().catch(console.error);
    }
  }

  public onInputFocusOut(event: FocusEvent) {
    if (this.isInputDiameter(event.target))
      this.checkDiam((event.target as HTMLInputElement));
    this.drawMesh().catch(console.error);
  }

  public onInputKeyDown(event: KeyboardEvent) {
    if (event.key == 'Enter' || event.key == 'Tab') {
      event.stopPropagation();
      event.preventDefault();
      if (this.isInputDiameter(event.target))
        this.checkDiam((event.target as HTMLInputElement));
      // Focus du prochain input
      this.focusNextInput((event.target as HTMLInputElement), event.shiftKey);
    }
  }

  // Pour respecter la qty minimale saisie
  async onQtyChange() {
    if (+this.mInputQuantity.nativeElement.value < this.NbMinQtyMesh) {
      alert(await this.mTranslate.get('La quantité minimum est de').toPromise() + ' ' + this.NbMinQtyMesh);
    }
    this.mInputQuantity.nativeElement.value = Math.max(+this.mInputQuantity.nativeElement.value, this.NbMinQtyMesh).toString();
  }

  public focusNextInput(input: HTMLInputElement, focusLastInput: boolean) {
    const nextInput = CUtilit.getNextFocusableInput(document.getElementById('dialog-content'), input, focusLastInput);
    if (nextInput) {
      nextInput.focus();
      nextInput.select();
    }
  }

  public isInputDiameter(eventTarget: EventTarget | null): boolean {
    return (
      eventTarget === this.mInputDiameterHorizontal.nativeElement ||
      eventTarget === this.mInputDiameterVertical.nativeElement
    );
  }

  public checkDiam(inputElem: HTMLInputElement) {
    const diamGradeValue = inputElem.value;

    if (!diamGradeValue)
      return;

    const diamGrade = GradeManager.separateDiamGrade(diamGradeValue);

    const checkGradeResult = GradeManager.getGradeFromDiam(diamGrade.diam, this.mArrayGrade);
    setTimeout(() => {
      if (checkGradeResult.found)
        inputElem.value = diamGrade.diam + checkGradeResult.gradeCode;
      else
        inputElem.value = '';
      //inputElem.focus();
    });
  }

  public onValueMeshChange(ev: Event) {
    this.resolveMesh(ev);
    this.drawMesh().catch(console.error);
  }

  public onTotalFocusIn(ev: Event) {
    const input = ev.target as HTMLInputElement;
    if (!input.value) {
      const meshAxe: WMeshAxes | undefined = this.getMeshAxesFromIdInput(input);
      if (!meshAxe)
        return;
      let axeTotalLength = meshAxe == 'HORIZONTAL' ? +this.HTML_TotalLengthHorizontal : +this.HTML_TotalLengthVertical;
      if (!axeTotalLength) {
        axeTotalLength = this.getWMeshTotalLength(meshAxe);
        if (axeTotalLength)
          input.value = axeTotalLength.toString();
      }
    }
  }

  private getWMeshTotalLength(meshAxe: WMeshAxes): number {
    const verticalMeshValue: WMeshAxesInformation = this.generateMeshAxesValue('VERTICAL');
    const horizontalMeshValue: WMeshAxesInformation = this.generateMeshAxesValue('HORIZONTAL');
    const meshAxeValueToUse = meshAxe == 'HORIZONTAL' ? horizontalMeshValue : verticalMeshValue;
    const otherAxeStartValue = meshAxe == 'HORIZONTAL' ? verticalMeshValue.startValue : horizontalMeshValue.startValue;
    const otherAxeEndValue = meshAxe == 'HORIZONTAL' ? verticalMeshValue.endValue : horizontalMeshValue.endValue;
    return WMeshUtils.getWMeshTotalLength(meshAxeValueToUse, otherAxeStartValue, otherAxeEndValue);
  }

  private getMeshAxesFromIdInput(htmlInput: HTMLInputElement): WMeshAxes | undefined {
    switch (htmlInput.id) {
      case this.HTML_MESH_INPUT_ID.totalLengthVertical:
      case this.HTML_MESH_INPUT_ID.nbBarsVertical:
      case this.HTML_MESH_INPUT_ID.stepVertical:
      case this.HTML_MESH_INPUT_ID.diameterVertical:
      case this.HTML_MESH_INPUT_ID.startMeasureHorizontal: // Debut fin influe sur l'axe opposé
      case this.HTML_MESH_INPUT_ID.endMeasureHorizontal: // Debut fin influe sur l'axe opposé
        return 'VERTICAL';
      case this.HTML_MESH_INPUT_ID.totalLengthHorizontal:
      case this.HTML_MESH_INPUT_ID.nbBarsHorizontal:
      case this.HTML_MESH_INPUT_ID.stepHorizontal:
      case this.HTML_MESH_INPUT_ID.diameterHorizontal:
      case this.HTML_MESH_INPUT_ID.startMeasureVertical: // Debut fin influe sur l'axe opposé
      case this.HTML_MESH_INPUT_ID.endMeasureVertical: // Debut fin influe sur l'axe opposé
        return 'HORIZONTAL';
      default:
        return undefined;
    }
  }

  private getInput(inputId: string): {
    Input?: HTMLInputElement,
    Axis: WMeshAxes,
    InputType: MeshInputType
  } {
    switch (inputId) {
      // Vertical
      case this.HTML_MESH_INPUT_ID.diameterVertical:     return { Input: this.mInputDiameterVertical.nativeElement,      Axis: 'VERTICAL', InputType: 'diameter' };
      case this.HTML_MESH_INPUT_ID.totalLengthVertical:  return { Input: this.mInputLengthVertical.nativeElement,        Axis: 'VERTICAL', InputType: 'length' };
      case this.HTML_MESH_INPUT_ID.stepVertical:         return { Input: this.mInputStepVertical.nativeElement,          Axis: 'VERTICAL', InputType: 'step' };
      case this.HTML_MESH_INPUT_ID.startMeasureVertical: return { Input: this.mInputStartMeasureVertical.nativeElement,  Axis: 'VERTICAL', InputType: 'startOffset' };
      case this.HTML_MESH_INPUT_ID.endMeasureVertical:   return { Input: this.mInputEndMeasureVertical.nativeElement,    Axis: 'VERTICAL', InputType: 'endOffset' };
      case this.HTML_MESH_INPUT_ID.nbBarsVertical:       return { Input: this.mInputNbBarVertical.nativeElement,         Axis: 'VERTICAL', InputType: 'nbBars' };
      case 'offsetsVertical':                 return { Input: undefined,                                      Axis: 'VERTICAL', InputType: 'offsets' };
      // Horizontal
      case this.HTML_MESH_INPUT_ID.diameterHorizontal:     return { Input: this.mInputDiameterHorizontal.nativeElement,      Axis: 'HORIZONTAL', InputType: 'diameter' };
      case this.HTML_MESH_INPUT_ID.totalLengthHorizontal:  return { Input: this.mInputLengthHorizontal.nativeElement,        Axis: 'HORIZONTAL', InputType: 'length' };
      case this.HTML_MESH_INPUT_ID.stepHorizontal:         return { Input: this.mInputStepHotizontal.nativeElement,          Axis: 'HORIZONTAL', InputType: 'step' };
      case this.HTML_MESH_INPUT_ID.startMeasureHorizontal: return { Input: this.mInputStartMeasureHorizontal.nativeElement,  Axis: 'HORIZONTAL', InputType: 'startOffset' };
      case this.HTML_MESH_INPUT_ID.endMeasureHorizontal:   return { Input: this.mInputEndMeasureHorizontal.nativeElement,    Axis: 'HORIZONTAL', InputType: 'endOffset' };
      case this.HTML_MESH_INPUT_ID.nbBarsHorizontal:       return { Input: this.mInputNbBarHorizontal.nativeElement,         Axis: 'HORIZONTAL', InputType: 'nbBars' };
      case 'offsetsHorizontal':                 return { Input: undefined,                                        Axis: 'HORIZONTAL', InputType: 'offsets' };
      default: throw new Error('Unknown input ID');
    }
  }

  private findInput(axis: WMeshAxes, inputType: MeshInputType): string {
    switch (inputType) {
      case 'diameter':    return axis == 'HORIZONTAL' ? this.HTML_MESH_INPUT_ID.diameterHorizontal     : this.HTML_MESH_INPUT_ID.diameterVertical;
      case 'length':      return axis == 'HORIZONTAL' ? this.HTML_MESH_INPUT_ID.totalLengthHorizontal  : this.HTML_MESH_INPUT_ID.totalLengthVertical;
      case 'step':        return axis == 'HORIZONTAL' ? this.HTML_MESH_INPUT_ID.stepHorizontal         : this.HTML_MESH_INPUT_ID.stepVertical;
      case 'startOffset': return axis == 'HORIZONTAL' ? this.HTML_MESH_INPUT_ID.startMeasureHorizontal : this.HTML_MESH_INPUT_ID.startMeasureVertical;
      case 'endOffset':   return axis == 'HORIZONTAL' ? this.HTML_MESH_INPUT_ID.endMeasureHorizontal   : this.HTML_MESH_INPUT_ID.endMeasureVertical;
      case 'nbBars':      return axis == 'HORIZONTAL' ? this.HTML_MESH_INPUT_ID.nbBarsHorizontal       : this.HTML_MESH_INPUT_ID.nbBarsVertical;
      default: throw new Error('Unknown input type: ' + inputType);
    }
  }

  /**
   * Calcule une valeur du treillis à partir des autres valeurs saisies
   * @param inputId L'id de l'input à calculer
   */
  private calcInputFromId(inputId: string) {
    const input = this.getInput(inputId);
    if (input.Input)
      this.calcInput(input.InputType, input.Input, input.Axis);
  }

  /**
   * Calcule une valeur du treillis à partir des autres valeurs saisies
   * @param inputType Quel type de valeur doit être calculée
   * @param inputElement L'élément Input HTML si il y a
   * @param Axis Sur quel axe du treillis la valeur est saisie
   */
  private calcInput(inputType: MeshInputType, inputElement: HTMLInputElement | undefined, Axis: WMeshAxes) {
    //Inputs
    const inputLengthValue: string = Axis == 'VERTICAL' ? this.HTML_TotalLengthVertical : this.HTML_TotalLengthHorizontal;
    const inputStep = this.getInput(this.findInput(Axis, 'step'));
    const inputStartOffset = this.getInput(this.findInput(Axis, 'startOffset'));
    const inputEndOffset = this.getInput(this.findInput(Axis, 'endOffset'));
    const inputNbBars = this.getInput(this.findInput(Axis, 'nbBars'));
    if (!inputStep.Input || !inputNbBars.Input || !inputStartOffset.Input || !inputEndOffset.Input)
      return;
    switch (inputType) {
      case 'diameter':
        break;
      case 'length':
        if ((inputStep.Input.value == '') || (inputNbBars.Input.value == '')) {
          // On ne peut pas calculer la longueur si on a pas déjà saisi le pas et le nombre de barres
          return;
        }
        const verticalMeshInfo: WMeshAxesInformation = this.generateMeshAxesValue('VERTICAL');
        const horizontalMeshInfo: WMeshAxesInformation = this.generateMeshAxesValue('HORIZONTAL');
        this.calcTotalLength(verticalMeshInfo, horizontalMeshInfo);
        break;
      case 'step':
        if ((inputLengthValue == '') || (inputNbBars.Input.value == '')) {
          // On a besoin d'au moins la longueur et le nombre de barres (opt. : Start/End offset)
          return;
        }
        inputStep.Input.value = ((+inputLengthValue - (+inputStartOffset.Input.value + +inputEndOffset.Input.value)) / (+inputNbBars.Input.value - 1)).toString();
        break;
      case 'offsets':
      case 'startOffset':
      case 'endOffset':
        if ((inputLengthValue == '') || (inputStep.Input.value == '') || (inputNbBars.Input.value == '')) {
          // On a besoin de la longueur, du pas et du nb de barres
          return;
        }
        let remainingLength: number = +inputLengthValue - (+inputStep.Input.value * (+inputNbBars.Input.value - 1));
        switch (inputType) {
          case 'startOffset':
            remainingLength -= +inputEndOffset.Input.value;
            inputStartOffset.Input.value = remainingLength.toString();
            break;
          case 'endOffset':
            remainingLength -= +inputStartOffset.Input.value;
            inputEndOffset.Input.value = remainingLength.toString();
            break;
          case 'offsets':
            inputStartOffset.Input.value = (remainingLength / 2).toString();
            inputEndOffset.Input.value = (remainingLength / 2).toString();
            break;
        }
        break;
      case 'nbBars':
        if ((inputLengthValue == '') || (inputStep.Input.value == '')) {
          // Il faut avoir saisi au moins la longueur et le pas (opt. : Start/End offset)
          return;
        }
        if (+inputStep.Input.value == 0) {
          inputNbBars.Input.value = '0';
        } else {
          inputNbBars.Input.value = Math.trunc(((+inputLengthValue - (+inputStartOffset.Input.value + +inputEndOffset.Input.value)) / +inputStep.Input.value ) + 1).toString();
        }
        break;
    }
  }

  private resolveMesh(changedInputEvent: Event) {
    const htmlInput = (changedInputEvent.target as HTMLInputElement);
    const meshAxe: WMeshAxes | undefined = this.getMeshAxesFromIdInput(htmlInput);
    const otherAxe: WMeshAxes = meshAxe == 'HORIZONTAL' ? 'VERTICAL' : 'HORIZONTAL';
    // inputAxis = L'axe sur lequel on vient de saisir indépendemment de quel axe est impacté par la valeur
    const inputAxis: WMeshAxes | undefined = htmlInput.id in [this.HTML_MESH_INPUT_ID.startMeasureVertical, this.HTML_MESH_INPUT_ID.startMeasureHorizontal,
      this.HTML_MESH_INPUT_ID.endMeasureVertical, this.HTML_MESH_INPUT_ID.endMeasureHorizontal] ? otherAxe : meshAxe;
    if (!inputAxis)
      return;
    // Si on a pas saisi une seule valeur, on la calcule
    const missingValues: string[] = this.AxisMissingValues(inputAxis);
    // Calcul de la valeur manquante s'il n'y en a qu'une
    if (missingValues.length == 1) {
      const input = this.getInput(missingValues[0]);
      // Exception pour ne pas rendre la saisie compliquée on ne calcule pas le pas comme dans Armaor
      if (input.InputType != 'step') {
        this.calcInput(input.InputType, input.Input, input.Axis);
      }
    } else {
      const input = this.getInput(htmlInput.id);

      const inputNbBars = this.findInput(input.Axis, 'nbBars');
      const inputStartOffset = this.findInput(input.Axis, 'startOffset');
      const inputEndOffset = this.findInput(input.Axis, 'endOffset');

      switch (input.InputType) {
        case 'length':
        case 'step':
          //const inputEndOffset = this.findInput(input.Axis, 'endOffset');
          this.calcInputFromId(inputNbBars);
          this.calcInput( 'offsets', undefined, inputAxis);
          break;
        case 'startOffset':
          this.calcInputFromId( inputNbBars );
          this.calcInputFromId( inputEndOffset );
          break;
        case 'endOffset':
          this.calcInputFromId( inputNbBars );
          this.calcInputFromId( inputStartOffset );
          break;
        case 'nbBars':
          const inputLength = this.findInput(input.Axis, 'length');
          this.calcInputFromId( inputLength );
          break;
        default:
          const verticalMeshValue: WMeshAxesInformation = this.generateMeshAxesValue('VERTICAL');
          const horizontalMeshValue: WMeshAxesInformation = this.generateMeshAxesValue('HORIZONTAL');
          this.calcTotalLength(verticalMeshValue, horizontalMeshValue);
          break;
      }
    }
  }

  private calcTotalLength(verticalMeshValue: WMeshAxesInformation,
                          horizontalMeshValue: WMeshAxesInformation) {
    const hvTotalLength = WMeshUtils.getHVTotalLength(horizontalMeshValue, verticalMeshValue);
    if (hvTotalLength.vertical)
      this.applyTotalLength('VERTICAL', hvTotalLength.vertical.toString());
    if (hvTotalLength.horizontal)
      this.applyTotalLength('HORIZONTAL', hvTotalLength.horizontal.toString());
  }

  private applyTotalLength(axe: WMeshAxes, totalValue: string) {
    if (axe == 'HORIZONTAL')
      this.HTML_TotalLengthHorizontal = totalValue;
    else
      this.HTML_TotalLengthVertical = totalValue;
  }

  /**
	 * Dessine le mesh sur le canvas ou recuperer l'image du mesh depuis armaor
	 */
  private async drawMesh() {
    let selectedInputId = '';
    if (document.activeElement) selectedInputId = document.activeElement.id;
    // Recup des infos du mesh
    const verticalMeshValue: WMeshAxesInformation = this.generateMeshAxesValue('VERTICAL');
    const horizontalMeshValue: WMeshAxesInformation = this.generateMeshAxesValue('HORIZONTAL');

    // Avant on demandait au serveur de générer le dessin
    /*if (this.HTML_ShowRealShape) {
      // On envoi le mesh sur armaor pour recup le dessin
      this.mCpyAnaLine.setTypeWMesh(this.generateMeshCloseResult());
      this.HTML_SafeUrlImgShape = await this.mArmaServMethods.getImageMesh(this.mCpyAnaLine, this.canvasWidth, this.canvasHeight);

    } else {*/
      setTimeout(() => {
        // Clear du canvas
        CUtilForme.clearCanvas(this.mCanvasMesh.nativeElement);
        this.mCanvasMesh.nativeElement.height = this.canvasHeight;
        this.mCanvasMesh.nativeElement.width = this.canvasWidth;
        // Dessin du mesh
        WMeshUtils.drawMesh(this.mCanvasMesh.nativeElement, verticalMeshValue, horizontalMeshValue, false, selectedInputId, true);
      });
    //}
  }

  public onBtnClick(btn: 'OK'|'CANCEL'|'CLEAR') {
    switch (btn) {
      case 'OK':
        this.mCpyAnaLine.setTypeWMesh(this.generateMeshCloseResult());
        this.mDialogRef.close(this.mCpyAnaLine);
        break;
      case 'CANCEL':
        this.mDialogRef.close(false);
        break;
      case 'CLEAR':
        this.clearInput();
        break;
    }
  }

  public loadDataFromLine() {
    // Return si rien à charger
    const wMeshInformation = this.mCpyAnaLine.wMeshInformation;
    if (!wMeshInformation) {
      // On init la qty du mesh avec la qty par default
      this.mInputQuantity.nativeElement.value = this.NbMinQtyMesh.toString();
      return;
    }

    this.mInputItemNumber.nativeElement.value = String(wMeshInformation.itemNumber);
    this.mInputItemName.nativeElement.value = wMeshInformation.itemname;
    this.mInputRemark.nativeElement.value = wMeshInformation.remark;
    this.mInputQuantity.nativeElement.value = String(wMeshInformation.quantity);
    this.mInputBarmark.nativeElement.value = wMeshInformation.barmark;

    this.HTML_TotalWeightRounded = wMeshInformation.totalWeightRounded;

    this.setMeshInformation('VERTICAL', wMeshInformation.vertical, wMeshInformation.horizontal.startValue, wMeshInformation.horizontal.endValue);
    this.setMeshInformation('HORIZONTAL', wMeshInformation.horizontal, wMeshInformation.vertical.startValue, wMeshInformation.vertical.endValue);
  }

  private setMeshInformation(axes: WMeshAxes, information: WMeshAxesInformation, startPaddingValue: number, endPaddingValue: number) {
    if (axes == 'VERTICAL') {
      this.mInputNbBarVertical.nativeElement.value = String(information.nbBar);
      this.mInputStepVertical.nativeElement.value = String(information.step);
      this.mInputDiameterVertical.nativeElement.value = information.diameter ? information.diameter : '';
      this.mInputStartMeasureVertical.nativeElement.value = String(startPaddingValue);
      this.mInputEndMeasureVertical.nativeElement.value = String(endPaddingValue);
    } else {
      this.mInputNbBarHorizontal.nativeElement.value = String(information.nbBar);
      this.mInputStepHotizontal.nativeElement.value = String(information.step);
      this.mInputDiameterHorizontal.nativeElement.value = information.diameter ? information.diameter : '';
      this.mInputStartMeasureHorizontal.nativeElement.value = String(startPaddingValue);
      this.mInputEndMeasureHorizontal.nativeElement.value = String(endPaddingValue);
    }
  }

  public clearInput() {
    this.mInputItemNumber.nativeElement.value = '';
    this.mInputItemName.nativeElement.value = '';
    this.mInputRemark.nativeElement.value = '';
    this.mInputQuantity.nativeElement.value = '';
    this.mInputBarmark.nativeElement.value = '';
    this.mInputNbBarVertical.nativeElement.value = '';
    this.mInputStepVertical.nativeElement.value = '';
    this.mInputDiameterVertical.nativeElement.value = '';
    this.mInputStartMeasureVertical.nativeElement.value = '';
    this.mInputEndMeasureVertical.nativeElement.value = '';
    this.mInputNbBarHorizontal.nativeElement.value = '';
    this.mInputStepHotizontal.nativeElement.value = '';
    this.mInputDiameterHorizontal.nativeElement.value = '';
    this.mInputStartMeasureHorizontal.nativeElement.value = '';
    this.mInputEndMeasureHorizontal.nativeElement.value = '';
    this.HTML_TotalLengthVertical = '';
    this.HTML_TotalLengthHorizontal = '';
    this.drawMesh().catch(console.error);
  }

  public AxisMissingValues(axis: WMeshAxes): string[] {
    const missingValues: string[] = [];
    if (axis == 'VERTICAL') {
      if (this.HTML_TotalLengthVertical == '')                        missingValues.push(this.HTML_MESH_INPUT_ID.totalLengthVertical);
      if (this.mInputStepVertical.nativeElement.value == '')          missingValues.push(this.HTML_MESH_INPUT_ID.stepVertical);
      if (this.mInputStartMeasureVertical.nativeElement.value == '')  missingValues.push(this.HTML_MESH_INPUT_ID.startMeasureVertical);
      if (this.mInputEndMeasureVertical.nativeElement.value == '')    missingValues.push(this.HTML_MESH_INPUT_ID.endMeasureVertical);
      if (this.mInputNbBarVertical.nativeElement.value == '')         missingValues.push(this.HTML_MESH_INPUT_ID.nbBarsVertical);
    } else {
      if (this.HTML_TotalLengthHorizontal == '')                        missingValues.push(this.HTML_MESH_INPUT_ID.totalLengthHorizontal);
      if (this.mInputStepHotizontal.nativeElement.value == '')          missingValues.push(this.HTML_MESH_INPUT_ID.stepHorizontal);
      if (this.mInputStartMeasureHorizontal.nativeElement.value == '')  missingValues.push(this.HTML_MESH_INPUT_ID.startMeasureHorizontal);
      if (this.mInputEndMeasureHorizontal.nativeElement.value == '')    missingValues.push(this.HTML_MESH_INPUT_ID.endMeasureHorizontal);
      if (this.mInputNbBarHorizontal.nativeElement.value == '')         missingValues.push(this.HTML_MESH_INPUT_ID.nbBarsHorizontal);
    }
    return missingValues;
  }

  public generateMeshAxesValue(type: WMeshAxes): WMeshAxesInformation {
    if (type == 'VERTICAL') {
      return {
        nbBar: +this.mInputNbBarVertical.nativeElement.value,
        step: +this.mInputStepVertical.nativeElement.value,
        diameter: this.mInputDiameterVertical.nativeElement.value,
        startValue: +this.mInputStartMeasureHorizontal.nativeElement.value,
        endValue: +this.mInputEndMeasureHorizontal.nativeElement.value
      };
    } else {
      return {
        nbBar: +this.mInputNbBarHorizontal.nativeElement.value,
        step: +this.mInputStepHotizontal.nativeElement.value,
        diameter: this.mInputDiameterHorizontal.nativeElement.value,
        startValue: +this.mInputStartMeasureVertical.nativeElement.value,
        endValue: +this.mInputEndMeasureVertical.nativeElement.value
      };
    }
  }

  public generateMeshCloseResult(): JsLineWMesh {
    // Cehck de la qty min avant de recup le linedec
    const meshQty = Math.max(+this.mInputQuantity.nativeElement.value, this.NbMinQtyMesh);
    return {
      itemNumber: +this.mInputItemNumber.nativeElement.value,
      itemname: this.mInputItemName.nativeElement.value,
      remark: this.mInputRemark.nativeElement.value,
      quantity: meshQty,
      barmark: this.mInputBarmark.nativeElement.value,
      vertical: this.generateMeshAxesValue('VERTICAL'),
      horizontal: this.generateMeshAxesValue('HORIZONTAL'),
      totalWeightRounded: this.HTML_TotalWeightRounded ? this.HTML_TotalWeightRounded : 0
    };
  }
}
